import { useStepNavigation } from "ah_utility/NavigationEngine";
import { useLocation } from "react-router-dom";
import { backStepById, useGetInformationSteps } from "ah_utility/workflow";
var useUI = function (navigate, setAccountType, setAccountNumber, setAccountName, setCardSelected) {
    var pathname = useLocation().pathname;
    useGetInformationSteps(pathname);
    var dataNavigation = useStepNavigation({ currentStepId: pathname }).navigation;
    var clickCard = function (item) {
        setAccountType(item.cardValues[0]);
        setAccountNumber(item.cardValues[1]);
        setAccountName(item.cardValues[2]);
        setCardSelected(true);
    };
    var handlePrevious = function () {
        backStepById(pathname);
        navigate("".concat(dataNavigation === null || dataNavigation === void 0 ? void 0 : dataNavigation.back));
    };
    return {
        clickCard: clickCard,
        handlePrevious: handlePrevious,
    };
};
export default useUI;
